import { get, post } from '../core'

export namespace pricing {
  /** 获取调起 fastspring 的 checkout 弹窗的参数 */
  export function checkout(planId: string) {
    return post<{
      data: {
        payload: string
        key: string
      }
    }>('/payment/fastspring/checkout', {}, { planId })
  }

  /** 临时使用 */
  export function getPlanId() {
    return get<{ planId: string }>('/payment/fastspring/get_plan_id')
  }

  export function getPlanList() {
    return get<{
      catalogs: {
        Starter: Models.Plan
        [key: string]: Models.Plan
      }
    }>('/payment/get_catalogs')
  }
}
